import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { filter, map, take } from 'rxjs';
import { AuthService } from './auth.service';

export const userLoggedInGuard = (redirectUrl: string, loggedIn = true): CanActivateFn =>
  (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const router = inject(Router);
    const auth = inject(AuthService);

    // user$ starts as `undefined` until Supabase resolves the session.
    // Waiting here prevents the guard from making a wrong redirect decision
    // during the brief window before onAuthStateChange has fired.
    return auth.user$.pipe(
      filter(user => user !== undefined),
      take(1),
      map(user => !!user === loggedIn || router.createUrlTree([redirectUrl]))
    );
  }
